var LiveChat;

LiveChat = window.LiveChat != null ? window.LiveChat : window.LiveChat = {};

LiveChat.init = function(arg, done) {
  var liveChat, ref;
  liveChat = arg.liveChat;
  if (!(((liveChat != null ? liveChat.scriptUrl : void 0) != null) && (liveChat != null ? (ref = liveChat.configArray) != null ? ref.length : void 0 : void 0) > 0)) {
    return done();
  }
  return $(function() {
    window._bcvma = liveChat.configArray;
    if (!window.bcLoaded) {
      window.bcLoaded = true;
      $.getScript(liveChat.scriptUrl);
    }
    setInterval(function() {
      var $bcanchor, $bcfloating;
      $bcfloating = $(".bcFloat img, .bcStatic img");
      $bcanchor = $(".bcFloat a, .bcStatic a");
      if ($bcfloating != null ? $bcfloating.length : void 0) {
        $bcfloating.attr("alt", "LiveChat");
        if ($bcanchor != null ? $bcanchor.length : void 0) {
          $bcanchor.removeAttr("href").attr({
            "role": "button",
            "aria-label": "LiveChat",
            "tabindex": "0"
          }).css({
            "cursor": "pointer",
            "display": "block"
          });
          if ($bcfloating.attr('src').indexOf('clear.gif') !== -1) {
            return $bcanchor.css("display", "none");
          }
        }
      }
    }, 1000);
    return done();
  });
};

module.exports = LiveChat;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9saXZlX2NoYXQvZnJvbnRlbmQvbGl2ZV9jaGF0LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvbGl2ZV9jaGF0L2Zyb250ZW5kL2xpdmVfY2hhdC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxRQUFBLDZCQUFXLE1BQU0sQ0FBQyxXQUFQLE1BQU0sQ0FBQyxXQUFZOztBQUU5QixRQUFRLENBQUMsSUFBVCxHQUFnQixTQUFDLEdBQUQsRUFBYSxJQUFiO0FBQ2QsTUFBQTtFQURnQixXQUFEO0VBQ2YsSUFBQSxDQUFBLENBQXFCLDBEQUFBLGtFQUE4QyxDQUFFLHlCQUF2QixHQUFnQyxDQUE5RSxDQUFBO0FBQUEsV0FBTyxJQUFBLENBQUEsRUFBUDs7U0FFQSxDQUFBLENBQUUsU0FBQTtJQUNBLE1BQU0sQ0FBQyxNQUFQLEdBQWdCLFFBQVEsQ0FBQztJQUV6QixJQUFBLENBQU8sTUFBTSxDQUFDLFFBQWQ7TUFDRSxNQUFNLENBQUMsUUFBUCxHQUFrQjtNQUNsQixDQUFDLENBQUMsU0FBRixDQUFZLFFBQVEsQ0FBQyxTQUFyQixFQUZGOztJQUtBLFdBQUEsQ0FBWSxTQUFBO0FBQ1YsVUFBQTtNQUFBLFdBQUEsR0FBYyxDQUFBLENBQUUsNkJBQUY7TUFDZCxTQUFBLEdBQVksQ0FBQSxDQUFFLHlCQUFGO01BQ1osMEJBQUcsV0FBVyxDQUFFLGVBQWhCO1FBQ0UsV0FBVyxDQUFDLElBQVosQ0FBaUIsS0FBakIsRUFBd0IsVUFBeEI7UUFFQSx3QkFBRyxTQUFTLENBQUUsZUFBZDtVQUNFLFNBQVMsQ0FBQyxVQUFWLENBQXFCLE1BQXJCLENBQTRCLENBQUMsSUFBN0IsQ0FDRTtZQUFBLE1BQUEsRUFBUSxRQUFSO1lBQ0EsWUFBQSxFQUFjLFVBRGQ7WUFFQSxVQUFBLEVBQVksR0FGWjtXQURGLENBSUMsQ0FBQyxHQUpGLENBS0U7WUFBQSxRQUFBLEVBQVMsU0FBVDtZQUNBLFNBQUEsRUFBVSxPQURWO1dBTEY7VUFRQSxJQUFHLFdBQVcsQ0FBQyxJQUFaLENBQWlCLEtBQWpCLENBQXVCLENBQUMsT0FBeEIsQ0FBZ0MsV0FBaEMsQ0FBQSxLQUFrRCxDQUFDLENBQXREO21CQUNFLFNBQVMsQ0FBQyxHQUFWLENBQWMsU0FBZCxFQUF5QixNQUF6QixFQURGO1dBVEY7U0FIRjs7SUFIVSxDQUFaLEVBaUJFLElBakJGO1dBbUJBLElBQUEsQ0FBQTtFQTNCQSxDQUFGO0FBSGM7O0FBaUNoQixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
